import React from "react";

const ValueChangeCircle = ({ percentage = 0, size = 150, strokeWidth = 12 }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  // تخصيص ألوان التغير في القيمة
  const getColor = () => {
    if (percentage < 20) return "#27ae60"; // أخضر
    if (percentage < 50) return "#f39c12"; // برتقالي
    return "#e74c3c"; // أحمر
  };

  return (
    <div className="d-flex flex-column align-items-center">
      <svg width={size} height={size}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="transparent"
          stroke="#e0e0e0"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="transparent"
          stroke={getColor()}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
        <text
          x="50%"
          y="50%"
          dominantBaseline="middle"
          textAnchor="middle"
          fontSize="22"
          fontWeight="bold"
          fill="#34495e"
          style={{ fontFamily: "Cairo" }}
        >
          {percentage.toFixed(1)}%
        </text>
      </svg>
      <p style={{ fontFamily: "Cairo", fontWeight: "500", marginTop: "10px" }}>
        معدل التغير في قيمة المشروع
      </p>
    </div>
  );
};

export default ValueChangeCircle;
